import { useContext } from 'react';
import { createContext } from 'react';
import React from 'react';

import { ConditionLayoutProps } from '../@types/ConditionLayoutProps';

type CLContext = { conditionIsTrue: boolean; setConditionIsTrue: any; Then: any; Else?: any; mzShowThen?: boolean };

export const ConditionLayoutContext = createContext<CLContext>({} as CLContext);

ConditionLayoutContext.displayName = 'ConditionLayout';

const ConditionLayoutProvider = ({ Then, children, Else, conditionIsTrue: cit, mzShowThen }: ConditionLayoutProps) => {
	const [conditionIsTrue, setConditionIsTrue] = React.useState(cit ?? true);
	return (
		<ConditionLayoutContext.Provider value={{ conditionIsTrue, setConditionIsTrue, Then, Else, mzShowThen }}>
			{children}
		</ConditionLayoutContext.Provider>
	);
};

export const useConditionLayout = () => {
	const context = useContext(ConditionLayoutContext);

	return context;
};

export default ConditionLayoutProvider;
